import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Link, Typography } from "@mui/material";
import { GlobalContext } from "../../context/globalContext";
import TkTable from "../../components/atoms/TkTable";
import { httpAPI_STA002 } from "./api/request";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import { headList, searchFormList, searchFormSchema } from "./parts";
import TkButton from "../../components/atoms/TkButton";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { TkGetCode } from "../../utils/TkGetCode";
import { changeAmountFormat } from "../../utils/useTools";
import TkSearchForm from "../../components/molecules/TkSearchForm";
import "./_style.scss";
import {
  AttachmentRegistStatus,
  FormClassRetire,
  FormKbn,
  RetireContinuousTransferClassification,
  RetirementAllowanceInvoiceTotalingApplyUseStatus,
  Status,
  YesOrNoFlug,
} from "../../assets/data/Constants";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { BusinessContext } from "../../context/businessContext";
import _ from "lodash";
import { TkRouteContext } from "../../context/tkRouteContext";
import { IAPI_STA002_Response } from "../../type/apiType";

/**
 * SCRC060031 退職者状況　管理
 * @return SCRC060031 退職者状況　管理
 */
const SCRC060031 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const context = businessState.retirement;
  const [stateSearchList, setStateSearchList] = useState<any>();
  const searchList = useRef(_.cloneDeep(searchFormList));
  const [bodyList, setBodyList] = useState<any>([]);
  const isKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const { state: routerState, setState: setRouterState } =
    useContext(TkRouteContext);
  const searchParam = useRef<any>({});

  useEffect(() => {
    const routerList = routerState.routerList;
    if (!routerList?.find((item) => item.href === "/SCRC060031")) return;
    const updateRouterList = routerList?.filter((item) =>
      ["/SCRC020001", "/SCRD310001", "/SCRC060031"].includes(item.href ?? "")
    );
    if (_.isEqual(updateRouterList, routerList)) return;
    setRouterState({ routerList: updateRouterList });
  }, [routerState.routerList, setRouterState]);

  const handleCallApi = async (param: any) => {
    try {
      // 退職者状況一覧参照API実行
      const res = await httpAPI_STA002({
        contractorNo: isKiko
          ? businessState.common?.contractorNo
          : state.authInfo?.contractorNo,
        ...param,
      });
      setBodyList([]);

      if (res.resultCd === "I0000") {
        const statusReferBodyList = funBodyList(res);
        setBodyList(statusReferBodyList);
        searchParam.current = param;
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch {
      navigate("/error");
    }
  };

  useEffect(() => {
    let resArr = searchList.current;
    for (let i in context) {
      let targetObj = resArr.find((item: any) => item.keyword === i)!;
      targetObj &&
        (targetObj.wantToSetValue = context[i as keyof typeof context]);
    }
    setStateSearchList([...resArr]);

    handleCallApi({ ...context });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function funBodyList(res: IAPI_STA002_Response): any[] {
    const specialStatus = [
      Status["届出待ち"],
      Status["差戻し一時保存"],
      Status["添付待ち"],
    ];

    const retireFromClassForCheck = [
      FormClassRetire["退職所得の源泉徴収票_退職届1枚目"],
      FormClassRetire["退職所得の源泉徴収票_退職届2枚目"],
      FormClassRetire["退職所得の源泉徴収票_退職届3枚目"],
    ];

    const bodyList = res.retireList?.map((item) => {
      let unnecessary = false;
      let registerFlag = false;
      let formFlag = false;
      let dontAddFalgForSyorui = true;
      let withholdingRegisteredFlg = false;
      item.formList?.forEach((item2: any) => {
        if (
          item2.formKbn === FormKbn["退職書類"] &&
          retireFromClassForCheck.includes(item2.formClass)
        ) {
          unnecessary = true;
        }
        if (
          item2.formKbn === FormKbn["退職書類"] &&
          !retireFromClassForCheck.includes(item2.formClass) &&
          item2.formStatus === AttachmentRegistStatus["後で登録"]
        ) {
          registerFlag = true;
        }
        if (
          item2.formKbn === FormKbn["退職書類"] &&
          retireFromClassForCheck.includes(item2.formClass) &&
          item2.formStatus === AttachmentRegistStatus["後で登録"]
        ) {
          formFlag = true;
        }
        if (
          item2.formKbn === FormKbn["退職書類"] &&
          !retireFromClassForCheck.includes(item2.formClass)
        ) {
          dontAddFalgForSyorui = false;
        }
        if (
          item2.formKbn === FormKbn["退職書類"] &&
          retireFromClassForCheck.includes(item2.formClass)
        ) {
          withholdingRegisteredFlg = true;
        }
      });

      return [
        {
          children: `${item.staffNo}:${item.staffNameKanji}`, //「職員番号:法人職員氏名(漢字)」
          align: "left",
        },
        {
          children: item.birthday, //法人職員生年月日
          align: "center",
        },
        {
          children: `${item.facilityNo ?? ""}:${
            item.facilityNo === "999" ? "対象外施設" : item.facilityName ?? ""
          }`, //「施設番号:施設名称」
          align: "left",
        },
        {
          children: item.retireDate, //退職日
          align: "center",
        },
        {
          //処理状況
          children: (
            <Box className="pbtn">
              <Box>
                {item.retireContinuousTransferClassification ===
                  RetireContinuousTransferClassification["継続異動以外"] &&
                !specialStatus.includes(
                  item.retireContinuousTransferProcessingStatus as Status
                ) &&
                (item.retirementAllowanceInvoiceTotalingApplyUseStatus ===
                  RetirementAllowanceInvoiceTotalingApplyUseStatus["未提出"] ||
                  item.retirementAllowanceInvoiceTotalingApplyUseStatus ===
                    RetirementAllowanceInvoiceTotalingApplyUseStatus[
                      "退職金請求済み(受理待ち)"
                    ]) ? (
                  <Box className="pbtn">
                    {item.transferCdFlg === YesOrNoFlug["有"] ? (
                      <Link
                        data-testid="SCRC060031LinkPost"
                        className="SCRC060031LinkName"
                        target="_blank"
                        onClick={() => handleLinkOrButton(item, "/SCRC060129")}
                      >
                        届出済み
                      </Link>
                    ) : (
                      <Typography>届出済み</Typography>
                    )}
                    <TkButton
                      onClick={() => handleLinkOrButton(item, "/SCRC060132")}
                    >
                      取り下げ
                    </TkButton>
                  </Box>
                ) : item.retireContinuousTransferClassification ===
                    RetireContinuousTransferClassification["継続異動以外"] &&
                  !specialStatus.includes(
                    item.retireContinuousTransferProcessingStatus as Status
                  ) &&
                  item.retirementAllowanceInvoiceTotalingApplyUseStatus ===
                    RetirementAllowanceInvoiceTotalingApplyUseStatus[
                      "退職金請求済み"
                    ] ? (
                  <Link
                    data-testid="SCRC060031LinkPost"
                    className="SCRC060031LinkName"
                    target="_blank"
                    onClick={() => handleLinkOrButton(item, "/SCRC060129")}
                  >
                    届出済み
                  </Link>
                ) : item.retireContinuousTransferClassification ===
                    RetireContinuousTransferClassification["継続異動以外"] &&
                  !specialStatus.includes(
                    item.retireContinuousTransferProcessingStatus as Status
                  ) &&
                  item.retirementAllowanceInvoiceTotalingApplyUseStatus ===
                    RetirementAllowanceInvoiceTotalingApplyUseStatus[
                      "合算済み"
                    ] ? (
                  <Link
                    data-testid="SCRC060031LinkPost"
                    className="SCRC060031LinkName"
                    target="_blank"
                    onClick={() => handleLinkOrButton(item, "/SCRC060129")}
                  >
                    届出済み
                  </Link>
                ) : item.retireContinuousTransferClassification ===
                    RetireContinuousTransferClassification["継続異動以外"] &&
                  item.retireContinuousTransferProcessingStatus ===
                    Status["差戻し一時保存"] ? (
                  <Box className="pbtn">
                    <Typography>差戻中</Typography>
                    <TkButton
                      onClick={() => handleLinkOrButton(item, "/SCRC060120")}
                    >
                      訂正入力
                    </TkButton>
                  </Box>
                ) : item.retireContinuousTransferClassification ===
                    RetireContinuousTransferClassification["継続異動以外"] &&
                  item.retireContinuousTransferProcessingStatus ===
                    Status["添付待ち"] ? (
                  <Box className="pbtn">
                    {item.transferCdFlg === YesOrNoFlug["有"] ? (
                      <Link
                        data-testid="SCRC060031LinkPost"
                        className="SCRC060031LinkName"
                        target="_blank"
                        onClick={() => handleLinkOrButton(item, "/SCRC060129")}
                      >
                        添付待ち
                      </Link>
                    ) : (
                      <Typography>添付待ち</Typography>
                    )}
                    <TkButton
                      onClick={() => handleLinkOrButton(item, "/SCRC060132")}
                    >
                      取り下げ
                    </TkButton>
                  </Box>
                ) : item.retireContinuousTransferClassification ===
                  RetireContinuousTransferClassification["継続異動"] ? (
                  <Link
                    data-testid="SCRC060031LinkTransfer"
                    className="SCRC060031LinkName"
                    target="_blank"
                    onClick={() => handleLinkOrButton(item, "/SCRC060130")}
                  >
                    継続異動済
                  </Link>
                ) : null}
              </Box>
            </Box>
          ),
          align: "left",
        },
        {
          //書類の送付
          children: (
            <Box>
              {item.retireContinuousTransferClassification ===
              RetireContinuousTransferClassification["継続異動"] ? (
                <Typography>不要</Typography>
              ) : item.retireContinuousTransferProcessingStatus ===
                Status["差戻し一時保存"] ? (
                <Typography>非該当</Typography>
              ) : unnecessary ? (
                <Typography>添付なし</Typography>
              ) : registerFlag ? (
                <TkButton onClick={() => handleRegister(item, "/SCRC060121")}>
                  登録
                </TkButton>
              ) : dontAddFalgForSyorui ? (
                <Typography>添付なし</Typography>
              ) : (
                <Typography>登録済み</Typography>
              )}
            </Box>
          ),
          align: "left",
        },
        {
          //源泉徴収票
          children: (
            <Box>
              {item.retireContinuousTransferClassification ===
              RetireContinuousTransferClassification["継続異動"] ? (
                <Typography>不要</Typography>
              ) : item.retireContinuousTransferProcessingStatus ===
                Status["差戻し一時保存"] ? (
                <Typography>非該当</Typography>
              ) : formFlag ? (
                <TkButton onClick={() => handleRegister(item, "/SCRC060125")}>
                  登録
                </TkButton>
              ) : withholdingRegisteredFlg ? (
                <Typography>登録済み</Typography>
              ) : (
                <Typography>添付なし</Typography>
              )}
            </Box>
          ),
          align: "left",
        },
        {
          //退職金請求/合算申出
          children: TkGetCode(
            RetirementAllowanceInvoiceTotalingApplyUseStatus,
            item.retirementAllowanceInvoiceTotalingApplyUseStatus
          ),
          align: "left",
        },
        {
          // 退職手当金額
          children: changeAmountFormat(item.retirementAllowanceAmt ?? ""),
          align: "right",
          forSort: item.retirementAllowanceAmt,
        },
        {
          //源泉徴収額
          children: changeAmountFormat(item.totalTaxAmt ?? ""),
          align: "right",
          forSort: item.totalTaxAmt,
        },
      ];
    });

    return bodyList ?? [];
  }

  const handleLinkOrButton = (data: any, path: any) => {
    setBusinessState({
      ...businessState,
      retirement: searchParam.current,
    });
    navigate(path, { state: { applyId: data.applyId, staffNo: data.staffNo } });
  };

  const handleRegister = (data: any, path: any) => {
    switch (path) {
      case "/SCRC060121":
        setBusinessState({
          ...businessState,
          job_32: {
            ...businessState.job_32,
            staffNo: data?.staffNo,
            staffNameKanji: data?.staffNameKanji,
            nRetireReasonCd: data?.retireReasonCd,
            retireProcedureReason: data?.retireProcedureReason,
          },
          retirement: searchParam.current,
        });
        break;
      case "/SCRC060125":
        setBusinessState({
          ...businessState,
          job_32: {
            ...businessState.job_32,
            facilityNo: data?.facilityNo,
            staffNo: data?.staffNo,
            staffNameKanji: data?.staffNameKanji,
          },
          retirement: searchParam.current,
        });
        break;
      default:
        return;
    }

    navigate(path, { state: { applyId: data.applyId } });
  };

  return (
    <Box data-testid="SCRC060031PageForTest" className="SCRC060031">
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLC060031_01}</TkInfoManual>
      <TkSearchForm
        listData={stateSearchList}
        ruleSchema={searchFormSchema}
        onSearch={handleCallApi}
      />
      <TkTable
        headList={headList}
        bodyList={bodyList}
        defaultRowsPerPage={10}
        pagin
        showUnit
      />
    </Box>
  );
};

export default SCRC060031;
